<template>
  <v-container id="monitor-de-atividades" class="px-6">
      <v-row>
          <v-col class="pb-1 pt-0" cols="12">
            <h1>Monitor de Recurso de Glosa</h1>
            <p class="mb-0">Filtre por datas de pagamentos e gerencie o envio de Recursos de Glosa conforme seus status.</p>
          </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0 px-1" cols="12">
            <FilterByPrestadorOperadora
            :filter="(formData) => getList(formData)"
            :filtrarPorCarteiras="filtrarPorCarteiras"
            nomeFiltroExterno="monitorGlosaFilter"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col class="pa-0 pl-2 pr-2 mb-1" cols="3">
          <v-card outlined style="box-shadow: 0 0 0px 2px #4a4a4a" class="p-card">
                <v-card-text class="pa-0">
                  <v-row class="ma-0 pt-3">
                    <v-col class="pa-0 ma-0" cols="12">
                      <v-toolbar color="rgba(0,0,0,0)" flat height="36px">
                        <v-toolbar-title class="ma-0 pa-0">
                          <p class="text-title mb-0 mt-0" style="color: #4a4a4a">
                            Total glosado
                            <br />
                            <small
                              >{{monitorGlosa.total_glosado.qtd_pagamentos}} PAGAMENTOS / {{monitorGlosa.total_glosado.qtd_operadoras}} OPERADORAS</small>
                          </p>
                        </v-toolbar-title>
                      </v-toolbar>
                    </v-col>
                     <v-col class="text-center mt-1 pa-0 " cols="12">
                      <b style="font-size:16px; color:#d0021b">{{monitorGlosa.total_glosado.total_glosado | formatPrice}}</b>
                      <div class="text-legend pt-1 pb-2">TOTAL AGUARDANDO RECURSO</div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
        </v-col>
        <!-- <v-col class="pa-0 px-2" cols="4">
          <v-card outlined style="box-shadow: 0 0 0px 2px #d0021b" class="p-card">
                <v-card-text class="pa-0">
                  <v-row class="ma-0 pt-3">
                    <v-col class="pa-0 ma-0" cols="12">
                      <v-toolbar color="rgba(0,0,0,0)" flat height="36px">
                        <v-toolbar-title class="ma-0 pa-0">
                          <p class="text-title mb-0 mt-0" style="color: #d0021b">
                            Pagamentos sem carteira
                            <br />
                            <small
                              >97 PAGAMENTOS / 12 OPERADORAS</small>
                          </p>
                        </v-toolbar-title>
                      </v-toolbar>
                    </v-col>
                     <v-col class="text-center mt-1 pa-0 " cols="12">
                      <b style="font-size:16px; color:#272525d1">R$ 225.770,90</b>
                      <div class="text-legend pt-1 pb-2">TOTAL CALCULADO</div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
        </v-col> -->
        <v-col class="pa-0 pr-4 pl-2" cols="4">
              <v-card
                outlined
                style="box-shadow: 0 0 0px 2px #32b88b"
                class="p-card"
              >
                <v-card-text class="pa-0">
                  <v-row class="ma-0 pt-3">
                    <v-col class="pa-0 ma-0" cols="12">
                      <v-toolbar color="rgba(0,0,0,0)" flat height="36px">
                        <v-toolbar-title class="ma-0 pa-0">
                          <p class="text-title mb-0 mt-0" style="color: #32b88b">
                            Concluídos
                            <!-- em {{monthYear}} -->
                            <br />
                            <small
                              >{{monitorGlosa.concluidos.qtd_pagamentos}} PAGAMENTOS / {{monitorGlosa.concluidos.qtd_operadoras}} OPERADORAS</small>
                          </p>
                        </v-toolbar-title>
                        <v-toolbar-items class="mb-4 ml-2" width="20px">
                          <v-menu offset-y max-width="20%">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                class="px-0 py-0"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                icon
                              >
                                <v-icon
                                  class="px-1 pt-0"
                                  color="primary"
                                  size="14px"
                                  @click="openInfo = true"
                                  >fa-info-circle</v-icon
                                >
                              </v-btn>
                            </template>
                            <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                              <p style="font-width: 24px">Pagamentos de recursos glosas Concluídos.</p>
                            </v-list>
                          </v-menu>
                        </v-toolbar-items>
                        <v-spacer></v-spacer>
                      </v-toolbar>

                    </v-col>
                    <v-col class="text-center mt-1 pa-0 " cols="4">
                      <b style="font-size:16px; color:#32b88b">{{monitorGlosa.concluidos.valor_recursado | formatPrice}}</b>
                      <div class="text-legend pt-1 pb-2">VALOR RECURSADO</div>
                    </v-col>
                    <v-col class="text-center mt-1 pa-0" cols="4">
                       <b style="font-size:16px; color:#d0021b">{{monitorGlosa.concluidos.valor_acatado | formatPrice}}</b>
                      <div class="text-legend pt-1 pb-2">VALOR ACATADO</div>
                    </v-col>
                    <v-col class="text-center mt-1 pa-0" cols="4">
                       <b style="font-size:16px; color:#d0021b">{{monitorGlosa.concluidos.valor_acatado/monitorGlosa.total_glosado.total_glosado | formatPercent }}</b>
                      <div class="text-legend pt-1 pb-2">% ACATADO</div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
        </v-col>
        <v-col class="py-1" cols="12">
          <CardAtividades
            :list="monitorGlosa"
            :filter="(formData) => filterList(formData)"
            :parameters="parameters"
            :monthYear="monthYear"
            :setFilter="(etapa, criticidade)=>setFilter(etapa, criticidade)"
          />
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import CardAtividades from './monitor_atividades/CardAtividades'
import FilterByPrestadorOperadora from "./monitor_atividades/Filter"
import moment from "moment"
moment.locale('pt-BR')
export default {
    components: {
        CardAtividades,
        FilterByPrestadorOperadora
    },
    data() {
        return {
          countDownTimer: null,
          display: '',
          filter: null,
          filtrarPorCarteiras: false,
          monthYear: null,
          operadoras: [],
          parameters: null,
          prestadores: [],
          selected: {},
          monitorGlosa: {
            total_glosado: {
                qtd_pagamentos: 0,
                qtd_operadoras: 0,
                total_glosado: 0.0
            },
            pagamentos_sem_carteira: {
                qtd_pagamentos: 0,
                qtd_operadoras: 0,
                total_calculado: 0.0
            },
            concluidos: {
                qtd_pagamentos: 0,
                qtd_operadoras: 0,
                valor_acatado: 0.0,
                valor_recursado: 0.0,
                mes_referente: ""
            },
            nao_iniciados: {
                qtd_pagamentos: 0,
                qtd_operadoras: 0,
                dados: {
                    qtd_pagamentos_acima_prazo: 0.0,
                    porc_pagamentos_acima_prazo: 0.0,
                    valor_calculado_acima_prazo: 0.0,
                    porc_valor_calculado_acima_prazo: 0.0,
                    qtd_pagamentos_criticos: 0,
                    porc_pagamentos_criticos: 0.0,
                    valor_calculado_criticos: 0.0,
                    porc_valor_calculado_criticos: 0.0,
                    qtd_pagamentos_dentro_prazo: 0,
                    porc_pagamentos_dentro_prazo: 0.0,
                    valor_calculado_dentro_prazo: 0.0,
                    porc_valor_calculado_dentro_prazo: 0.0
                },
                valor_total: 0.0
            },
            em_analise: {
                qtd_pagamentos: 0,
                qtd_operadoras: 0,
                dados: {
                    qtd_pagamentos_acima_prazo: 0,
                    porc_pagamentos_acima_prazo: 0.0,
                    valor_calculado_acima_prazo: 0.0,
                    porc_valor_calculado_acima_prazo: 0.0,
                    qtd_pagamentos_criticos: 0,
                    porc_pagamentos_criticos: 0.0,
                    valor_calculado_criticos: 0.0,
                    porc_valor_calculado_criticos: 0.0,
                    qtd_pagamentos_dentro_prazo: 0,
                    porc_pagamentos_dentro_prazo: 0.0,
                    valor_calculado_dentro_prazo: 0.0,
                    porc_valor_calculado_dentro_prazo: 0.0
                },
                valor_total: 0.0
            },
            em_transmissao: {
                qtd_pagamentos: 0,
                qtd_operadoras: 0,
                automatico: {
                    qtd_pagamentos_criticos: 0,
                    porc_pagamentos_criticos: 0.0,
                    valor_calculado_criticos: 0.0,
                    porc_valor_calculado_criticos: 0.0,
                    qtd_pagamentos_dentro_prazo: 0,
                    porc_pagamentos_dentro_prazo: 0.0,
                    valor_calculado_dentro_prazo: 0.0,
                    porc_valor_calculado_dentro_prazo: 0.0
                },
                manual: {
                    qtd_pagamentos_criticos: 0,
                    porc_pagamentos_criticos: 0.0,
                    valor_calculado_criticos: 0.0,
                    porc_valor_calculado_criticos: 0.0,
                    qtd_pagamentos_dentro_prazo: 0,
                    porc_pagamentos_dentro_prazo: 0.0,
                    valor_calculado_dentro_prazo: 0.0,
                    porc_valor_calculado_dentro_prazo: 0.0
                },
                valor_total: 0.0
            },
            com_critica: {
                qtd_pagamentos: 0,
                qtd_operadoras: 0,
                dados: {
                    qtd_pagamentos_criticos: 0,
                    porc_pagamentos_criticos: 0.0,
                    valor_calculado_criticos: 0.0,
                    porc_valor_calculado_criticos: 0.0,
                    qtd_pagamentos_dentro_prazo: 0,
                    porc_pagamentos_dentro_prazo: 0.0,
                    valor_calculado_dentro_prazo: 0.0,
                    porc_valor_calculado_dentro_prazo: 0.0
                },
                valor_total: 0.0
            },
            pronto_envio: {
                qtd_pagamentos: 0,
                qtd_operadoras: 0,
                dados: {
                    qtd_pagamentos_acima_prazo: 0,
                    porc_pagamentos_acima_prazo: 0.0,
                    valor_calculado_acima_prazo: 0.0,
                    porc_valor_calculado_acima_prazo: 0.0,
                    qtd_pagamentos_criticos: 0,
                    porc_pagamentos_criticos: 0.0,
                    valor_calculado_criticos: 0.0,
                    porc_valor_calculado_criticos: 0.0,
                    qtd_pagamentos_dentro_prazo: 0,
                    porc_pagamentos_dentro_prazo: 0.0,
                    valor_calculado_dentro_prazo: 0.0,
                    porc_valor_calculado_dentro_prazo: 0.0
                },
                valor_total: 0.0
            },
            transmitidos:{
              porc_aconcluir: 0,
              porc_enviado: 0,
              porc_valor_aconcluir: 0,
              porc_valor_enviado: 0,
              qtd_aconcluir: 0,
              qtd_enviado: 0,
              qtd_operadoras: 0,
              qtd_pagamentos: 0,
              valor_aconcluir: 0,
              valor_enviado: 0,
              valor_total: 0
            }
        }
      }
    },
    filters: {
      formatPrice(value) {
          let val = (value/1).toFixed(2).replace('.', ',')
          return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      formatPercent(value) {
        let val = (value*100).toFixed(1).replace('.', ',')
        return val.toString() + "%"
      }
    },
    computed: {
        ...mapState({
            grupoEconomico: (state) => state.permissions.grupoEconomico,
            grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
            monitorRecursoGlosa: (state) => state.recebiveis.monitorRecursoGlosa
        }),
    },
    beforeMount() {
        this.getParametrizacao()
    },
    mounted() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
        // let opts = {
        //     grupoEconomico: this.grupoEconomico,
        //     modulo_operadora: "faturamento"
        // };
        // this.getOperadoras(opts).then(list=> {
        //     this.operadoras = list
        // })
        this.monthYear = moment().format('MMMM')
        // this.refreshTimer()
        // this.startTimer(300)
        this.temPermissaoCarteira()
    },
    methods: {
        ...mapActions({
            getOperadoras: "permissions/getOperadoras",
            getMonitorRecursoGlosa: "recebiveis/getMonitorRecursoGlosa"
        }),
        getParametrizacao(){
            let opts = {
            query: [
                {
                Modulo: "Portal",
                Acao: "getparametrizacoes",
                Payload: {
                    grupo_economico: this.grupoEconomico,
                },
                },
            ],
            noLoader: true,
            };
            this.$store.dispatch("request/doRequest", opts).then(resp => this.parameters = resp.parametros)
        },
        temPermissaoCarteira(){
          this.$store.dispatch("recebiveis/verificaPermissaoCarteiras").then(resp => this.filtrarPorCarteiras = resp)
        },
         setFilter(etapa, criticidade){
            let filter = {
              filterData: {
                ...this.filter,
               carteira: null,
               criticidade: criticidade? criticidade : null,
               owner_id: null,
               etapa: etapa,
               data_ate: null,
               data_entre: null,
               evento_id: []
              },
              filterName: 'recursosGlosaFilter',
              redirect: true
            }
            this.$store.commit('recebiveis/setFilter', filter, { root:true })
          },
        startTimer(duration) {
            let timer = duration, minutes, seconds
            this.countDownTimer = setInterval(() => {
                minutes = parseInt((timer / 60).toString(), 10)
                seconds = (timer % 60).toString(), 10
                minutes = minutes < 10 ? "00:0" + minutes : "00:" + minutes
                seconds = seconds < 10 ? "0" + seconds : seconds
                this.display = minutes + ":" + seconds
                if (--timer < 0) {
                    timer = duration
                    this.refreshTimer()
                }
            }, 1000);
        },
        refreshTimer () {
            if (this.$route.path != '/faturamento/monitordeatividades') {
                clearInterval(this.countDownTimer)
            } else {
               let payload = {
                    grupo_economico: this.grupoEconomico,
                    prestador_id: [],
                    operadora_ans_id: []
                }
                this.getmonitorcronogramas(payload)
            }
        },
        getList(formData) {
          this.filter = formData
          let opts = {grupo_economico: this.grupoEconomico, ...formData}
          this.getMonitorRecursoGlosa(opts).then((resp) => {
            this.monitorGlosa = resp
          })
          this.selected = opts
        },
        filterList(val, blockUpdate) {
            let select = this.selected
            if (val == "sem-cronograma") {
                this.$router.push('/faturamento/lotessemcronograma')
            } else {
                let filter = {
                    prestador_id: select.prestador_id? select.prestador_id : [],
                    operadora_ans_id: select.operadora_ans_id? select.operadora_ans_id : [],
                    card_name: val,
                    owner_id: null
                }
                if(!blockUpdate){
                    this.$store.commit("faturamento/setFilter", filter, {root:true})
                }
                this.$router.push('/faturamento/cronogramas')
            }
        }
    }
}
</script>
<style>
.text-title {
  font-size: 20px;
  font-weight: 700;
  font-family: "Cairo";
  line-height: 15px;
}
small {
  font-size: 12px;
  font-weight: 500;
  font-family: "Cairo";
}
.text-legend {
  font-size: 10px;
  line-height: 12px;
}
.v-toolbar__content .v-btn.v-btn--icon.v-size--default,
.v-toolbar__extension .v-btn.v-btn--icon.v-size--default {
  height: 0px;
  width: 0px;
}
.text-qtd {
  font-family: "Cairo";
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 3px !important;
}
.theme--light.v-icon:focus::after {
  display: none !important;
}
.value-text{
  font-size: 18px;
  font-family: "Cairo";
  color: #272525d1;
  font-weight: 600;
}
</style>
